import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  constructor(private _sessionService: SessionService) {}

  log(message, data:any = {}, sendToSentry = true) {
    const evt = {
      message,
      level: Sentry.Severity.Log,
      extra: data,
      user: {}
    }

    const usr = this._sessionService.getCurrentUser();
    if (usr) {
      evt.user = {
        id: usr.id,
        email: usr.email
      }
      evt.extra.userDetails = usr;
    } else if (data.user && data.user.profile && data.user.profile.sub) {
      evt.user = {
        id: data.user.profile.sub,
        email: data.user.profile.sub
      }
    }
    console.log(message, data);
    if (sendToSentry) {
      Sentry.captureEvent(evt);
    }
  }

  error(error: Error, sendToSentry = true) {
    console.error(error);
    if (sendToSentry) {
      Sentry.captureException(error);
    }
  }

}